import { Component, OnInit, Inject } from '@angular/core';
import { listPagesDB } from 'src/app/shared/tables/list-pages';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-summer-internships-list',
  templateUrl: './summer-internships-list.component.html',
  styleUrls: ['./summer-internships-list.component.scss']
})
export class SummerInternshipsListComponent implements OnInit {

  constructor(private http: HttpClient, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  public lists = [];
  message = null;
  class = null;

  ngOnInit() {
    this.http.get<any>(this.api_endpoint+'/summerInternshipsHeading/').subscribe(
      data => {
        let headings = data.data;
        this.http.get<any>(this.api_endpoint+'/summerInternships/').subscribe(
          data => {
            data.data.map(item => {
              let head = headings.filter(o => o._id == item.heading ).map(a => a.heading);
              return {
                heading: head,
                title: item.title,
                _id: item._id,
              }
            }).forEach(element =>  this.lists.push(element) );
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        });
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }

  delete(id) {
    // console.log(this.Form.value)
    if(confirm("Are you sure to delete ")){
    this.http.delete<any>(this.api_endpoint+'/summerInternships/'+ id).subscribe(
      res => {
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Deleted';
          this.class = 'btn btn-success';
          window.location.reload();
        }
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
  });
  }
  }

}
